import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

import { setFiltersChange } from '../store/actions'

import trads from '../intl/trads.json'

import resetIcon from '../icons/reset.svg'

const ClearRefinements = ({ items, refine, classes = false }) => {
  const lang = useSelector(state => state.lang)
  const dispatch = useDispatch()

  const clear = () => {
    refine(items)

    setTimeout(() => {
      dispatch(setFiltersChange(0))
    }, 50)
  }

  return (
    <button onClick={() => clear()} className={`${classes ? classes : ''} button-refresh`}>
      <svg className="mr-2" width="32" height="32">
        <use xlinkHref={resetIcon.url} />
      </svg>
      <span className="hover-underline">{trads[lang].resetFilters}</span>
    </button>
  )
  }

const clearFilters = connectCurrentRefinements(ClearRefinements)

export default clearFilters